// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function ArrowSlantUnited(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "ArrowSlantUnited" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.8108 4.7027V2H22V11.1892H19.2973V6.61383L6.61383 19.2973L11.1892 19.2973V22H2V12.8108H4.7027L4.7027 17.3862L17.3862 4.7027H12.8108Z", fill: "currentColor" }))));
});
//# sourceMappingURL=ArrowSlantUnited.js.map